import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-historique-dossier',
  templateUrl: './historique-dossier.component.html',
  styleUrls: ['./historique-dossier.component.css']
})
export class HistoriqueDossierComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
